module.exports = __webpack_public_path__ + "static/media/FramePuzzlePrizes33.1dfb35c9.png";